import React, { useEffect, useState } from "react";
import TradeHistorySpot from "../TradeHistorySpot";
import BalanceFundSpot from "../BalanceFundSpot";
import BOT from "../BOT";

const SpotTrade = (props) => {
  const [activeKey, setActiveKey] = useState("1");
  const { type, apiKey, apiSecret, username, selectedapi } = props;

  const [exchangeInfo, setExchangeInfo] = useState();

  // useEffect(() => {
  //   setOption2(option);
  // }, [option]);


  const items = [
    // {
    //   key: "1",
    //   label: (
    //     <div className="px-4 md:px-10 text-xs md:text-sm">Active Bots</div>
    //   ),
    // },
    {
      key: "1",
      label: (
        <div className="px-4 md:px-10 text-xs md:text-sm">Trade History</div>
      ),
    },
    {
      key: "2",
      label: <div className="px-4 md:px-10 text-xs md:text-sm">Balance</div>,
    },
  ];

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  const renderContent = () => {
    switch (activeKey) {
      // case "1":
      //   return <BOT selectedapi={selectedapi}
      //     filter={type} userName={username} />;
      case "1":
        return <TradeHistorySpot data={{
          selectedapi: selectedapi,
          apiKey: apiKey,
          apiSecret: apiSecret,
          type: type,
          selectedOptionData: exchangeInfo,
        }} />;
      case "2":
        return <BalanceFundSpot data={{
          selectedapi: selectedapi,
          apiKey: apiKey,
          apiSecret: apiSecret,
          type: type,
          selectedOptionData: exchangeInfo,
        }} />;
      default:
        return null;
    }
  };

  return (
    <>
     
        <div className="text-black">
          <div className="tab-headers flex space-x-4 border-b">
            {items.map((item) => (
              <div
                key={item.key}
                className={`tab-header cursor-pointer p-2 ${activeKey === item.key
                  ? "border-b-2 border-black font-semibold"
                  : ""
                  }`}
                onClick={() => handleTabChange(item.key)}
              >
                {item.label}
              </div>
            ))}
          </div>

          <div className="tab-content mt-4">{renderContent()}</div>
        </div>
    

     
    </>
  );
};

export default SpotTrade;
